var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-details"},[_c('RIcon',{attrs:{"of":"Card","width":40}}),_vm._v(_vm._s(_vm.last4)+" "),_c('span',[_vm._v(_vm._s(_vm.expirationDate))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }